import { useQueries, UseQueryResult } from '@tanstack/react-query';
import { EVSE } from '../../models/EVSE.ts';
import { ChargingService } from '../../models/ChargingService.ts';
import { getEVSEs } from '../../api/charging-service.ts';

export function useChargingServicesInformation(
  services: ChargingService[] | undefined,
  selectedLocationId: string | undefined,
): UseQueryResult<EVSE[], Error>[] {
  const queries =
    services && selectedLocationId
      ? services.map((service) => ({
          queryKey: [
            'selectedLocation',
            selectedLocationId,
            'chargingServices',
            service.id,
            'evses',
          ] as const,
          queryFn: () => getEVSEs(service.id),
          enabled: !!service.id,
        }))
      : [];

  return useQueries({
    queries,
  }) as UseQueryResult<EVSE[], Error>[];
}
